export const email = (message) => ({
  pattern: { value: /^[^@\s]+@[^@\s]+\.[^@\s]+$/, message },
});
